function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing4, spacing8, spacing16, spacing24, spacing32, spacing48, spacing64, spacing128 } from "@churchofjesuschrist/eden-style-constants";
const gaps = {
  0: "0",
  4: spacing4,
  8: spacing8,
  16: spacing16,
  24: spacing24,
  32: spacing32,
  48: spacing48,
  64: spacing64,
  128: spacing128
};

const getRowGapSize = _ref => {
  let {
    rowGapSize,
    gapSize
  } = _ref;
  return gaps[rowGapSize] || gaps[gapSize];
};

const getColumnGapSize = _ref2 => {
  let {
    columnGapSize,
    gapSize
  } = _ref2;
  return gaps[columnGapSize] || gaps[gapSize];
};

const flexNamesMap = {
  start: "flex-start",
  center: "center",
  end: "flex-end"
};
const JustifyContentMap = { ...flexNamesMap,
  "space-between": "space-between"
};
const Container = styled.div.withConfig({
  componentId: "sc-lf3bj0-0"
})(["display:flex;flex-wrap:wrap;gap:", " ", ";justify-content:", ";", ""], getRowGapSize, getColumnGapSize, _ref3 => {
  let {
    align
  } = _ref3;
  return JustifyContentMap[align];
}, _ref4 => {
  let {
    verticalAlign
  } = _ref4;
  return verticalAlign ? `align-items: ${flexNamesMap[verticalAlign]};` : "";
});

const Row = _ref5 => {
  let {
    gapSize = "16",
    columnGapSize,
    rowGapSize,
    align = "start",
    verticalAlign,
    children,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Container, _extends({
    gapSize,
    columnGapSize,
    rowGapSize,
    align,
    verticalAlign
  }, rest), children);
};

const gapsKeys = Object.keys(gaps);
Row.propTypes = {
  /** Row items */
  children: PropTypes.node.isRequired,

  /** Gutter space between columns */
  gapSize: PropTypes.oneOf(gapsKeys),

  /** Overrides gapSize for column gutter space only */
  columnGapSize: PropTypes.oneOf(gapsKeys),

  /** Overrides gapSize for row gutter space only */
  rowGapSize: PropTypes.oneOf(gapsKeys),

  /** How to align the items horizontally in the row */
  align: PropTypes.oneOf(Object.keys(JustifyContentMap)),

  /** How to align the items vertically in the row */
  verticalAlign: PropTypes.oneOf(Object.keys(flexNamesMap))
};
export default Row;